import { render, staticRenderFns } from "./Procedencia.view.vue?vue&type=template&id=9697c002"
import script from "./Procedencia.view.vue?vue&type=script&lang=js"
export * from "./Procedencia.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports